var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelojOscuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 13C38.8366 13 46 10.7614 46 8C46 5.23858 38.8366 3 30 3C21.1634 3 14 5.23858 14 8C14 10.7614 21.1634 13 30 13Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8V12C46 14.761 38.837 17 30 17C21.163 17 14 14.761 14 12V8",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 44.6931C44.492 45.5751 46 46.7311 46 48.0001C46 50.7611 38.837 53.0001 30 53.0001C21.163 53.0001 14 50.7611 14 48.0001C14 46.7321 15.511 45.5741 18 44.6931",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48V52C46 54.761 38.837 57 30 57C21.163 57 14 54.761 14 52V48",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15.3059V17.3489C42 21.4859 39.869 25.3319 36.36 27.5249L35.272 28.2049C34.481 28.6999 34 29.5669 34 30.4999C34 31.4329 34.481 32.2999 35.272 32.7949L36.36 33.4749C39.869 35.6679 42 39.5129 42 43.6509V46.9999C42 48.1049 36.627 48.9999 30 48.9999C23.373 48.9999 18 48.1049 18 46.9999V43.6509C18 39.5139 20.131 35.6679 23.64 33.4749L24.728 32.7949C25.519 32.2999 26 31.4329 26 30.4999C26 29.5669 25.519 28.6999 24.728 28.2049L23.64 27.5249C20.131 25.3319 18 21.4869 18 17.3489V15.3059",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.634 48.3889L31.81 37.0169C31.428 36.3809 30.741 35.9919 30 35.9919C29.258 35.9919 28.571 36.3809 28.19 37.0169L21.366 48.3889",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 31,
    width: 1,
    height: 1,
    strokeWidth: 1,
    stroke: "#101820"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16V27",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 34V44",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46V50",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14V28",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30V34",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5 43V53",
    stroke: "#101820",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojOscuro);
export default __webpack_public_path__ + "static/media/relojOscuro.50ddeeab1c14485c1324dd4442018af0.svg";
export { ForwardRef as ReactComponent };